﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class KWRadio extends TKCustomElementFactory {
    radios: HTMLInputElement[];

    constructor() {
        super();

        this.radios = Array.from(this.querySelectorAll('input[type="radio"]')) as HTMLInputElement[];
    }

    getSelected(): HTMLInputElement | undefined {
        return this.radios.find((radio) => radio.checked);
    }

    getSelectedValue(): string | undefined {
        return this.getSelected()?.value;
    }
}